export const PRECALIFICACION_CREDITO_HIPOTECARIO_STEPCONFIG = '64b1a3f7c1bedd64021fd57b';
